import { render, staticRenderFns } from "./TextToDate.vue?vue&type=template&id=b877cf8e&scoped=true&"
import script from "./TextToDate.vue?vue&type=script&lang=js&"
export * from "./TextToDate.vue?vue&type=script&lang=js&"
import style0 from "./TextToDate.vue?vue&type=style&index=0&id=b877cf8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b877cf8e",
  null
  
)

export default component.exports